import React, { Component } from "react";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

import "./PhotoGallery.css";

class PhotoGallery extends Component {
  render() {
    let items = [];
    if (this.props.photos !== undefined) {
      items = this.props.photos.map((item, index) => {
        return (
          <div key={index}>
            <img className="photoGalleryStyleImg" src={item} alt="" />
          </div>
        );
      });
    }

    return (
      <Carousel
        className="carousel"
        dynamicHeight
        showStatus={false}
        showIndicators={false}
        useKeyboardArrows
        infiniteLoop
        autoPlay
        interval={5000}
      >
        {this.props.photos !== undefined ? items : null}
      </Carousel>
    );
  }
}

export default PhotoGallery;
